import { useDispatch } from 'react-redux';
import { setShowContactModal } from '@App/app.slice';
import { Button } from '@nazka/nazka.mapframe.components';

import './partners.styl';

function Partners() {
  const dispatch = useDispatch();

  return (
    <div className="partners">
      <div className="partners__new-partner">
        <div className="partners__new-partner__example">
          <p className="partners__new-partner__example__img" />
          <p className="partners__new-partner__example__text">
            NAARJOBS IS MEDE MOGELIJK GEMAAKT DOOR DIT BEDRIJF
          </p>
        </div>
        <div className="partners__new-partner__info">
          <h2>Word partner van NaarJobs</h2>
          <p className="partners__new-partner__info__text">
            Ondersteun de vrije toegang tot NaarJobs door mee te investeren in de verdere ontwikkeling en het online beschikbaar 
            houden van de tool. Als dank vermelden wij het logo van uw organisatie zichtbaar binnen de applicatie. Samen versterken 
            we de brug tussen mens en werk.
            <br />
            <br />
            Neem vrijblijvend contact met ons op via
            {' '}
            <a href="mailto:info@naarjobs.be" className="partners__new-partner__info__text__link">
              info@naarjobs.be
            </a>
            {' '}
            of laat een bericht achter via ons contactformulier. We gaan graag met u in gesprek over de mogelijkheden.
          </p>
        </div>
      </div>
      <div className="partners__list">
        <div className="partners__list__partner">
          <p className="partners__list__partner__text">
            Ontwikkeld door
          </p>
          <img
            className="partners__list__partner__img" 
            src="/img/logo/nazka.svg"
            alt="Logo - Nazka"
          />
        </div>
        <div className="partners__list__partner">
          <p className="partners__list__partner__text">
            In samenwerking met
          </p>
          <img
            className="partners__list__partner__img" 
            src="/img/logo/mobile21.svg"
            alt="Logo - Mobile21"
          />
        </div>
        <div className="partners__list__partner">
          <p className="partners__list__partner__text">
            Met steun van de Federale Overheidsdienst 
            <br />
            Mobiliteit en Vervoer
          </p>
          <img 
            className="partners__list__partner__img"
            src="/img/logo/shift-your-mobility.svg"
            alt="Logo - Shift your mobility"
          />
        </div>
      </div>
    </div>
  )
}

export default Partners;
